// LICENSE_CODE ZON
'use strict';/*jslint ts:true*/
import etask from 'zetask';
// @ts-ignore
import {ms} from '/util/date.js';

export const retry_et = (cb: ()=>typeof etask, retry:number,
    fail_ret?: any)=>etask(function*(){
    while (true)
    {
        retry--;
        try {
            return yield cb();
        } catch(e){
            if (retry>0)
            {
                yield etask.sleep(ms.SEC);
                continue;
            }
            if (fail_ret!==undefined)
                return fail_ret;
            throw e;
        }
    }
});
